<template>
	<header>
		<div class="topBox widthBox acea-row row-middle hidden-xs-only">
			<router-link class="acea-row row-middle" to="/">
				<img :src="head.company_logo" class="logo">
				<img src="@/assets/pic_01.png" class="pic">
			</router-link>
			<span></span>
			<div>
				<p>{{head.company_describe1}}</p>
				<p class="color">{{head.company_describe2}}</p>
			</div>
		</div>
		
		<div class="topBox widthBox acea-row row-between-wrapper hidden-sm-and-up">
			<router-link class="acea-row row-middle" to="/">
				<img src="@/assets/logo.png" class="logo">
				<img src="@/assets/pic_01.png" class="pic">
			</router-link>
			<span @click="mobileLook" class="iconfont icon-ai-kind"></span>
		</div>
		<div id="nav" class="hidden-xs-only">
			<div class="widthBox">
				<router-link v-for="item in navmenulist" :to="item.href" class="navPage navItem">
					{{item.name}}
					<div class="navItemBox">
						<router-link v-for="it in item.son_navlist" class="navPage" :to="it.href">{{it.name}}</router-link>
					</div>
				</router-link>
			</div>
		</div>
		
		<div v-if="mobileShow" @click="mobileShowChange" data-type="hidden" class="navBg hidden-sm-and-up">
			<div id="navM">
				<div v-for="item in navS" class="navPage navItem">
					<div v-if="item.item" @click="item.show = true" class="row-between-wrapper acea-row">
						{{item.name}}
						<i class="el-icon-arrow-right"></i>
					</div>
					<router-link v-else data-type="hidden" style="border:none;padding:0;" class="navPage navItem" :to="item.url">
						<div data-type="hidden" @click="item.show = true" class="row-between-wrapper acea-row">
							{{item.name}}
							<i data-type="hidden" class="el-icon-arrow-right"></i>
						</div>
					</router-link>
					
					<div v-if="item.show&&item.item" @click="item.show = false" class="navItemBoxBg"></div>
					<div v-if="item.item&&item.show" class="navItemBox">
						<router-link data-type="hidden" v-for="it in item.item" class="navPage" :to="it.url">{{it.name}}</router-link>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
	  computed: {
	  	navmenulist() {
			
	  		return this.$store.state.config.navmenulist
	  	},
			head() {
	  		return this.$store.state.config.head
	  	},
	  },
	  data() {
	  	return {
	  		navS:[
				{
					name:'首页',
					url:'/',
					show:false
				},
				{
					name:'公司业务',
					url:'/corporate',
					show:false,
					item:[
						{
							name:'业务生态',
							url:'/business'
						},
						{
							name:'主营产品',
							url:'/product'
						},
						{
							name:'品牌优势',
							url:'/brand'
						}
					]
				},
				{
					name:'新闻资讯',
					url:'/news',
					show:false,
					item:[
						{
							name:'行业动态',
							url:'/dynamic'
						},
						{
							name:'科普知识',
							url:'/knowledge'
						}
					]
				},
				{
					name:'关于我们',
					url:'/about',
					show:false,
					item:[
						{
							name:'关于我们',
							url:'/company'
						},
						{
							name:'企业优势',
							url:'/advantage'
						}
					]
				}
			],
	  		mobileShow:false
	  	}
	  },
	  created() {
	  },
	  mounted() {
	  },
	  methods:{
		  mobileLook(){
			  this.mobileShow=true
			  var list = this.navS
			  list.map(item=>{
				  item.show=false
			  })
			  this.navS=list
		  },
		  mobileShowChange(e){
		  	var type = e.target.dataset.type
		  	if(type == 'hidden'){
		  		this.mobileShow=false
		  	}
		  },
	  }
	}
</script>

<style lang="scss">
	header{
		background:#F1F1F1;
		.topBox{
			padding:12px 0;
			.logo{
				width:74px;
				height:74px;
			}
			.pic{
				width:180px;
				margin-left:20px;
			}
			span{
				display: inline-block;
				width:1px;
				height:18px;
				background:#ccc;
				margin:0 30px;
			}
			div{
				p{
					color:#999;
				}
				.color{
					color:#124098;
					font-size:14px;
					margin-top:5px;
				}
			}
		}
		#nav{
			background:#144199;
			.navPage{
				display: inline-block;
				line-height:48px;
				color:#FFF;
				width:108px;
				text-align: center;
				font-size:14px;
				box-sizing: border-box;
				&:hover,&.router-link-exact-active{
					color:#144199;
					background:#FFF;
				}
			}
			.navItem{
				display: inline-block;
				line-height:48px;
				color:#FFF;
				width:108px;
				text-align: center;
				font-size:14px;
				position: relative;
				cursor: pointer;
				.navItemBox{
					display: none;
				}
				&:hover{
					.navItemBox{
						display: block;
						position: absolute;
						left:0;
						top:48px;
						background:#FFF;
						padding:10px 0;
						z-index: 99;
						a{
							color:#666;
							line-height:32px;
						}
					}
				}
			}
			
			
		}
	}
	@media screen and(max-width:768px) {
		header{
			height:62px;
			background:none;
			.topBox{
				position: fixed;
				left:0;
				top:0;
				z-index: 110;
				background:#FFF;
				padding:12px 15px;
				.logo{
					width:38px;
					height:38px;
				}
				.pic{
					width:80px;
					margin-left:20px;
				}
				span{
					font-size:18px;
					width:24px;
					height:24px;
					text-align: center;
					line-height:24px;
					background:none;
					color:#144199;
					margin:0;
				}
			}
			
			#navM{
				background:#124098;
				height:100%;
				width:60%;
				position: relative;
				a,.navItem{
					display: block;
					color:#FFF;
					border-bottom:1px solid #FFF;
					font-size:14px;
					line-height:48px;
					padding:0 10px;
					&>div{
						font-size:14px;
						line-height:48px;
					}
				}
				.navItemBoxBg{
					position: fixed;
					left:0;
					top:60px;
					z-index: 101;
					background:rgba($color: #000000, $alpha: 0.2);
					width:30%;
					height:calc(100% - 60px);
				}
				.navItemBox{
					position: absolute;
					left:100px;
					top:0;
					width:70%;
					height:100%;
					z-index: 102;
					background:#124098;
				}
			}
			.navBg{
				position: fixed;
				left:0;
				top:60px;
				z-index: 100;
				background:rgba($color: #000000, $alpha: 0.4);
				width:100%;
				height:calc(100% - 60px);
			}
		}
	}
</style>
